import z from 'zod';
import { scheduleMessageDataTimeSchema } from './utils/zod-schema';
import { ChatMessageSchedule, MessageSchedule } from '@/types/generated/graphql';
import { ChatAttachment } from '@modules/conversations/conversation.types';

export type ScheduleMessageDataType = z.infer<ReturnType<typeof scheduleMessageDataTimeSchema>>;

export enum ScheduleModeEnum {
  INITIAL_SCHEDULE = 'initialSchedule',
  RESCHEDULE = 'reschedule',
}

export enum MessageModeEnum {
  SEND = 'send',
  UPDATE = 'update',
}

export enum MessageDropDownOptionsEnum {
  EDIT = 'edit',
  DELETE = 'delete',
  SEND = 'send',
  RESCHEDULE = 'reschedule',
}

export type UseScheduleMessageParamsProps = {
  onSuccess?: () => void;
};

export type UseUpdateScheduleMessageParams = {
  onSuccess?: () => void;
};

export type ScheduledMessageItemProps = {
  message: MessageSchedule | null;
  isLast?: boolean;
};

export type ScheduleMessageModalProps = {
  scheduledMessageCount: number;
};

export type ScheduleTimeDropDownProps = {
  to: string;
  from: string;
  roomId?: number;
  onClose: () => void;
};

export type SelectScheduleTimeModalProps = {
  to: string;
  from: string;
  roomId?: number;
};

export type ScheduledChatMessageItemProps = {
  row: ChatMessageSchedule;
  attachments: ChatAttachment[];
  roomId: number;
  isLast?: boolean;
};

export type ScheduledChatMessagesModalProps = {
  roomId: number;
};

export type UpdateMessageParameters = {
  messageId: string;
  scheduledTime: string;
};

export type MessageScheduleState = {
  messageMode: MessageModeEnum;
  setMessageMode: (mode: MessageModeEnum) => void;

  scheduleMode: ScheduleModeEnum;
  setScheduleMode: (mode: ScheduleModeEnum) => void;

  updateMessageParameters: UpdateMessageParameters | null;
  setUpdateMessageParameters: (params: UpdateMessageParameters | null) => void;

  scheduledMessageId: string | null;
  setScheduledMessageId: (id: string | null) => void;

  isScheduleMessagesModalOpen: boolean;
  openScheduleMessagesModal: () => void;
  closeScheduleMessagesModal: () => void;

  isScheduleTimeModalOpen: boolean;
  openScheduleTimeModal: () => void;
  closeScheduleTimeModal: () => void;

  isPopoverOpen: boolean;
  setPopoverOpen: (open: boolean) => void;

  deletePopoverOpen: boolean;
  setDeletePopoverOpen: (open: boolean) => void;

  resetToSendMode: () => void;
  resetAll: () => void;
};
